import formatRFC3339 from 'date-fns/formatRFC3339';
import keycloakService from '../../keycloak_service';

import { sinatraOrigin } from '../../config';

const postToApi = (sinatraEndpoint = '', fetchOptions = {}) => fetch(`${sinatraOrigin}/${sinatraEndpoint}`, fetchOptions).then(response => response.json())

export const fetchAssayResults = (queryParams) => {
  const [assay_id, startTimestamp, endTimestamp] = queryParams;
  const params = { assay_id };

  if (startTimestamp && endTimestamp) {
    params.start = formatRFC3339(startTimestamp);
    params.end = formatRFC3339(endTimestamp);
  }

  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakService.getAuthHeader(),
    },
    body: JSON.stringify(params),
  };

  return postToApi('v1/api/assays/get_assay_results', fetchOptions)
}

export default fetchAssayResults;
